var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorpw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0004 19.5V13.5H2.99963V19.5H5.99976V16.4999H13.5001V19.5H16.5V16.4999H24.0003V19.5H27.0004Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 6C20.9999 2.69097 18.3089 0 14.9999 0C11.6909 0 8.99988 2.69097 8.99988 6C8.99988 9.30903 11.6909 12 14.9999 12C18.3089 12 20.9999 9.30903 20.9999 6Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 25.5001C19.5 27.9854 17.4853 30.0001 14.9999 30.0001C12.5146 30.0001 10.4999 27.9854 10.4999 25.5001C10.4999 23.0147 12.5146 21 14.9999 21C17.4853 21 19.5 23.0147 19.5 25.5001Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00013 25.5001C9.00013 27.9854 6.98538 30.0001 4.50006 30.0001C2.01474 30.0001 0 27.9854 0 25.5001C0 23.0147 2.01474 21 4.50006 21C6.98538 21 9.00013 23.0147 9.00013 25.5001Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25.5001C30 27.9854 27.9853 30.0001 25.4999 30.0001C23.0146 30.0001 20.9999 27.9854 20.9999 25.5001C20.9999 23.0147 23.0146 21 25.4999 21C27.9853 21 30 23.0147 30 25.5001Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorpw);
export default __webpack_public_path__ + "static/media/corpw.fe55b02931aa72a6f948018765634e4a.svg";
export { ForwardRef as ReactComponent };